import React from 'react';
import { Link } from 'react-router-dom';
import './Programs.css';

const PROGRAMS = [
  {
    icon: '🎓',
    iconBg: 'color-teal',
    badge: 'Active',
    badgeClass: 'badge-active',
    title: 'Education for All',
    desc: 'Providing quality schooling, scholarships, and digital literacy to children in rural and tribal communities.',
    stat1: '8,500+ students',
    stat2: '65 schools',
    progress: 78,
    progressLabel: 'Annual goal',
  },
  {
    icon: '💊',
    iconBg: 'color-amber',
    badge: 'Ongoing',
    badgeClass: 'badge-active',
    title: 'Community Healthcare',
    desc: 'Free medical camps, maternal health, and preventive care for families in underserved areas.',
    stat1: '12,000+ checkups',
    stat2: '40 camps',
    progress: 65,
    progressLabel: 'Annual goal',
  },
  {
    icon: '👩‍💼',
    iconBg: 'color-blue',
    badge: 'Expanded',
    badgeClass: 'badge-expanded',
    title: 'Women Empowerment',
    desc: 'Skill development, micro-finance, and self-help groups enabling women to achieve economic independence.',
    stat1: '3,200 women',
    stat2: '18 districts',
    progress: 55,
    progressLabel: 'Annual goal',
  },
  {
    icon: '🌾',
    iconBg: 'color-green',
    badge: 'Active',
    badgeClass: 'badge-active',
    title: 'Sustainable Farming',
    desc: 'Organic farming, rainwater harvesting, and climate-smart agriculture for smallholder farmers.',
    stat1: '1,800 farmers',
    stat2: '24 villages',
    progress: 70,
    progressLabel: 'Annual goal',
  },
  {
    icon: '🧒',
    iconBg: 'color-rose',
    badge: 'Active',
    badgeClass: 'badge-active',
    title: 'Child Welfare',
    desc: 'Nutrition programs, after-school care, and child rights advocacy to protect vulnerable children.',
    stat1: '5,000+ children',
    stat2: '30 centers',
    progress: 80,
    progressLabel: 'Annual goal',
  },
  {
    icon: '🏘️',
    iconBg: 'color-purple',
    badge: 'New',
    badgeClass: 'badge-new',
    title: 'Rural Development',
    desc: 'Infrastructure, clean water, and sanitation projects to improve daily life in remote villages.',
    stat1: '120 villages',
    stat2: '5 districts',
    progress: 42,
    progressLabel: 'Annual goal',
  },
];

export default function Programs() {
  return (
    <section className="programs section" aria-labelledby="programs-heading">
      <div className="container">
        <div className="section-header">
          <span className="section-label">What We Do</span>
          <h2 className="section-title" id="programs-heading">Our Key Programs</h2>
          <p className="section-subtitle">
            Six interconnected programs working together to address the root causes of poverty and inequality — creating change that lasts generations.
          </p>
        </div>

        <div className="programs-grid" role="list">
          {PROGRAMS.map(p => (
            <article className="program-card" key={p.title} role="listitem">
              <div className="program-card-header">
                <span className={`program-card-badge ${p.badgeClass}`}>{p.badge}</span>
                <div className={`program-icon-wrap ${p.iconBg}`} aria-hidden="true">
                  {p.icon}
                </div>
                <h3 className="program-card-title">{p.title}</h3>
                <p className="program-card-desc">{p.desc}</p>
                <div className="program-meta">
                  <div className="program-meta-item">
                    <span className="icon" aria-hidden="true">👥</span>
                    <strong>{p.stat1}</strong> reached
                  </div>
                  <div className="program-meta-item">
                    <span className="icon" aria-hidden="true">📍</span>
                    Across <strong>{p.stat2}</strong>
                  </div>
                </div>
              </div>

              <div className="program-card-footer">
                <div className="program-progress-wrap">
                  <div className="progress-label">
                    <span className="progress-text">{p.progressLabel}</span>
                    <span className="progress-pct">{p.progress}%</span>
                  </div>
                  <div className="progress-bar-bg" role="progressbar" aria-valuenow={p.progress} aria-valuemin={0} aria-valuemax={100} aria-label={`${p.title} progress: ${p.progress}%`}>
                    <div className="progress-bar" style={{ width: `${p.progress}%` }} />
                  </div>
                </div>
                <Link to="/programs" className="program-link" aria-label={`Learn more about ${p.title}`}>
                  Learn <span aria-hidden="true">&rarr;</span>
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div style={{ textAlign: 'center', marginTop: '3rem' }}>
          <Link to="/programs" className="btn btn-outline">
            View All Programs
          </Link>
        </div>
      </div>
    </section>
  );
}
